module.exports = __webpack_public_path__ + "static/media/saltTruckCropped.228cb61f.jpg";